// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"ed7ea06b","313":"16598a8a"}[chunkId] + ".chunk.css";
};